import PropTypes from "prop-types";
import React from "react";
import { reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { injectIntl, intlShape } from "react-intl";

import { loadBenefitPlans, loadAccounts } from "actions/claimActions";
import {
  getBenefitPlan,
  getDefaultBenefitPlan,
  getAllBenefitPlans,
  getAccountsById,
} from "reducers/claimsReducer";
import { Card, CardSection, Toolbar, ToolbarSection, Form, Loader } from "cxa-components";
import AccountsList from "components/claim/AccountsList";
import { SelectField } from "cxa-form-field";
import { enrichAccounts } from "./util";
import messages from "components/messagesDescription";

const formName = "claimAccountsForm";

let ClaimAccountsForm = injectIntl(({ benefitPlans, intl }) => (
  <Form inline>
    <SelectField
      label={intl.formatMessage(messages.planYearDescription)}
      name="benefitPeriod"
      inlineBoxed
      items={benefitPlans.map(item => ({
        value: item.planID,
        label: item.planName,
      }))}
    />
  </Form>
));

ClaimAccountsForm.propTypes = {
  benefitPlans: PropTypes.array,
};

ClaimAccountsForm = reduxForm({
  form: formName,
  enableReinitialize: true,
})(ClaimAccountsForm);

class ClaimAccountsPage extends React.Component {
  state = {
    isFetching: true,
  };

  componentDidMount() {
    this.props.loadBenefitPlans();
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.fetching) {
      this.setState({
        isFetching: false,
      });
    }

    if (nextProps.benefitPeriod != this.props.benefitPeriod && nextProps.benefitPlan) {
      // Expect this to be replaced by benefitPeriod instead of using planEnd
      this.props.loadAccounts(nextProps.benefitPeriod, nextProps.benefitPlan.planEnd);
    }
  }

  render() {
    const isFetching = this.state.isFetching;

    if (isFetching) {
      return <Loader />;
    }

    const { benefitPlans, accounts = [], pageFields, login, intl, ...props } = this.props;
    const claimAccountNotesForDisplay = intl.formatMessage(
      messages.claimAccountNotesForDisplayDescription
    );
    return (
      <div>
        <h2>{intl.formatMessage(messages.accountsOverviewDescription)}</h2>
        <Card>
          <CardSection>
            <Toolbar>
              <ToolbarSection>
                <ClaimAccountsForm benefitPlans={benefitPlans} {...props} />
              </ToolbarSection>
            </Toolbar>
            <AccountsList rows={enrichAccounts(accounts, login)} columns={pageFields} />
          </CardSection>
          <div dangerouslySetInnerHTML={{ __html: claimAccountNotesForDisplay }} />
        </Card>
      </div>
    );
  }
}

ClaimAccountsPage.propTypes = {
  loadAccounts: PropTypes.func.isRequired,
  loadBenefitPlans: PropTypes.func.isRequired,
  setSelectedPlanYear: PropTypes.func,
  fetching: PropTypes.func,
  error: PropTypes.object,
  accounts: PropTypes.array,
  pageFields: PropTypes.array,
  login: PropTypes.object,
  benefitPlans: PropTypes.array,
  benefitPlan: PropTypes.object,
  isFetching: PropTypes.bool,
  benefitPeriod: PropTypes.string,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { login, claims: { accounts, benefitPlans } } = state;

  const selector = formValueSelector(formName);
  const benefitPeriod = selector(state, "benefitPeriod");

  return {
    login,
    pageFields: accounts.pageFields,
    accounts: getAccountsById(accounts, benefitPeriod),
    benefitPeriod,
    benefitPlan: getBenefitPlan(benefitPlans, benefitPeriod),
    benefitPlans: getAllBenefitPlans(benefitPlans),
    initialValues: {
      benefitPeriod: getDefaultBenefitPlan(benefitPlans),
    },
    isFetching: benefitPlans.isFetching,
  };
};

const mapDispatchToProps = {
  loadAccounts,
  loadBenefitPlans,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ClaimAccountsPage));



// WEBPACK FOOTER //
// ./components/claim/ClaimAccountsPage.jsx